import Loading from '../../../../shared/Loading/Loading';
import Header from './Header';
import Row from './Row';

const Table = ({
  loading,
  users,
  query,
  isEliminator,
  isEditor,
  selected,
  headerCheckboxRef,
  allSelected,
  toggleAllFiltered,
  toggleOne,
  sortConfig,
  handleSort,
  editUser,
  askDelete,
  stickyOffset,
}) => {
  return (
    <div className="hidden md:block w-full" style={{ overflow: 'clip' }}>
      {loading && (
        <div className="flex justify-center py-10">
          <Loading size="28" colorBase="white" colorAccent="personalized" double bold="8" />
        </div>
      )}
      {!loading && users.length === 0 && (
        <div className="text-center text-sm text-gray-500 py-6">
          {query ? `No hay coincidencias para "${query}"` : 'No hay usuarios disponibles'}
        </div>
      )}
      {!loading && users.length > 0 && (
        <table className="w-full divide-y divide-gray-200 table-fixed">
          <Header
            isEliminator={isEliminator}
            headerCheckboxRef={headerCheckboxRef}
            allSelected={allSelected}
            toggleAllFiltered={toggleAllFiltered}
            sortConfig={sortConfig}
            handleSort={handleSort}
            stickyOffset={stickyOffset}
          />
          <tbody className="bg-white divide-y divide-gray-200">
            {users.map((user) => (
              <Row
                key={user.Id}
                user={user}
                isEliminator={isEliminator}
                isEditor={isEditor}
                selected={selected}
                toggleOne={toggleOne}
                editUser={editUser}
                askDelete={askDelete}
              />
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default Table;
